import admincp from './admincp'
import area from './area'
import commodity from './commodity'
import company from './company'
import customer from './customer'
import dashboard from './dashboard'
import driver from './driver'
import journey from './journey'
import order from './order'
import partner from './partner'
import price from './price'
import sellingPrice from './selling-price'
import supply from './supply'
import system from './system'
import trip from './trip'
import vehicle from './vehicle'
import workflow from './workflow'

export default {
  ...dashboard,
  ...driver,
  ...vehicle,
  ...commodity,
  ...supply,
  ...company,
  ...customer,
  ...order,
  ...area,
  ...workflow,
  ...price,
  ...partner,
  ...trip,
  ...journey,
  ...system,
  ...admincp,
  ...sellingPrice
} as { [key: string]: any }
